import { DirittoAppBridge } from 'libs/DirittoAppBridge';
import { useCallback } from 'react';
import { useClient } from 'ui-hooks/useClient';

export const useExternalLink = () => {
  const client = useClient();

  return useCallback(
    (url: string, title?: string) => {
      if (client.isApp) {
        DirittoAppBridge.openExternalView(url, title);
      } else if (typeof window === 'object') {
        window.open(url, '_blank', 'noopener');
      }
    },
    [client.isApp],
  );
};
